import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../assets/css/modal.css";
import "../assets/css/login.css";
import Header from "./Header";
import Footer from "./Footer";
import Banner from "./Banner";
import AccessibilityModal from "./AccessibilityModal";

const Layout = () => {
  const [showModal, setShowModal] = useState(false);
  const { pathname } = useLocation();

  const toggleModal = () => setShowModal((open) => !open);

  return (
    <div className="micolor-jm">
      <Header />
      <button
        className="floating-button"
        onClick={toggleModal}
        aria-label="Abrir menú de accesibilidad"
      >
        <img
          src={require("../assets/clientes/iconoaccesibilidad.jpg")}
          alt="Menú de accesibilidad"
        />
      </button>
      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />
      {pathname === "/" && <Banner />}
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
